import React from "react";
import { SearchInput } from "components/input";
import { IoClose } from "react-icons/io5";
import styles from "./ClearableSearchInput.module.scss";

type Props = {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onClear: () => void;
	placeholder?: string;
};

const ClearableSearchInput = ({ value, onChange, onClear, placeholder }: Props) => {
	const showClear = value.length > 0;

	return (
		<div className={`${styles.wrap} ${showClear ? styles.wrapWithClear : ""}`}>
			<SearchInput
				search
				placeholder={placeholder}
				value={value}
				onChange={onChange}
			/>
			{showClear && (
				<button
					type="button"
					onClick={onClear}
					aria-label="Clear search"
					className={styles.clearButton}
				>
					<IoClose size={18} aria-hidden />
				</button>
			)}
		</div>
	);
};

export default ClearableSearchInput;
